module.exports = __webpack_public_path__ + "static/ASEBP-logo-515a9b6e38bd9a89d38e9bfa0a57d2ac.png";